var lightDetail = {"cheap":[
{
    "small": {price:119,length:7.8, wasserfest:40},
    "medium": {price:149,length:11.8, wasserfest:41},
    "large": {price:169,length:19.6, wasserfest:42},
    "x large": {price:189,length:29.5, wasserfest:43},
    "xx large": {price:229,length:39.3, wasserfest:44},
    "supersized":{price:329,length:59, wasserfest:45}
},
/*
2 letters
*/
{
    "small": {price:155,length:11.8, wasserfest:42},
    "medium": {price:159,length:19.6, wasserfest:43},
    "large": {price:214,length:29.5, wasserfest:44},
    "x large": {price:259,length:39.3, wasserfest:45},
    "xx large": {price:369,length:59, wasserfest:46},
    "supersized":{price:899,length:78.7, wasserfest:47}
},
/*
3 letters
*/
{
    "small": {price:169,length:19.6, wasserfest:43},
    "medium": {price:239,length:29.5, wasserfest:44},
    "large": {price:289,length:39.3, wasserfest:45},
    "x large": {price:419,length:59, wasserfest:46},
    "xx large": {price:939,length:78.7, wasserfest:47},
    "supersized":{price:1349,length:94.4, wasserfest:48}
},
/*
4 letters
*/
{
    "small": {price:179,length:19.6, wasserfest:43},
    "medium": {price:264,length:29.5, wasserfest:44},
    "large": {price:319,length:39.3, wasserfest:45},
    "x large": {price:489,length:59, wasserfest:46},
    "xx large": {price:979,length:78.7, wasserfest:47},
    "supersized":{price:1399,length:94.4, wasserfest:48}
},
/*
5 letters
*/
{
    "small": {price:189,length:19.6, wasserfest:43},
    "medium": {price:289,length:29.5, wasserfest:44},
    "large": {price:349,length:39.3, wasserfest:45},
    "x large": {price:539,length:59, wasserfest:46},
    "xx large": {price:1019,length:78.7, wasserfest:47},
    "supersized":{price:1449,length:94.4, wasserfest:48}
},
/*
6 letters
*/
{
    "small": {price:199,length:19.6, wasserfest:43},
    "medium": {price:314,length:29.5, wasserfest:44},
    "large": {price:379,length:39.3, wasserfest:45},
    "x large": {price:589,length:59, wasserfest:46},
    "xx large": {price:1059,length:78.7, wasserfest:47},
    "supersized":{price:1499,length:94.4, wasserfest:48}
},
/*
7 letters
*/
{
    "small": {price:219,length:19.6, wasserfest:43},
    "medium": {price:339,length:29.5, wasserfest:44},
    "large": {price:409,length:39.3, wasserfest:45},
    "x large": {price:629,length:59, wasserfest:46},
    "xx large": {price:1099,length:78.7, wasserfest:47},
    "supersized":{price:1549,length:94.4, wasserfest:48}
},
/*
8 letters
*/
{
    "small": {price:239,length:19.6, wasserfest:43},
    "medium": {price:364,length:29.5, wasserfest:44},
    "large": {price:439,length:39.3, wasserfest:45},
    "x large": {price:649,length:59, wasserfest:46},
    "xx large": {price:1139,length:78.7, wasserfest:47},
    "supersized":{price:1599,length:94.4, wasserfest:48}
},
/*
9 letters
*/
{
    "small": {price:259,length:19.6, wasserfest:43},
    "medium": {price:389,length:29.5, wasserfest:44},
    "large": {price:469,length:39.3, wasserfest:45},
    "x large": {price:679,length:59, wasserfest:46},
    "xx large": {price:1179,length:78.7, wasserfest:47},
    "supersized":{price:1649,length:94.4, wasserfest:48}
},
/*
10 letters
*/
{
    "small": {price:279,length:19.6, wasserfest:43},
    "medium": {price:414,length:29.5, wasserfest:44},
    "large": {price:499,length:39.3, wasserfest:45},
    "x large": {price:699,length:59, wasserfest:46},
    "xx large": {price:1219,length:78.7, wasserfest:47},
    "supersized":{price:1699,length:94.4, wasserfest:48}
},
/*
11 letters
*/
{
    "small": {price:299,length:19.6, wasserfest:43},
    "medium": {price:434,length:29.5, wasserfest:44},
    "large": {price:529,length:39.3, wasserfest:45},
    "x large": {price:729,length:59, wasserfest:46},
    "xx large": {price:1249,length:78.7, wasserfest:47},
    "supersized":{price:1749,length:94.4, wasserfest:48}
},
/*
12 letters
*/
{
    "small": {price:339,length:19.6, wasserfest:43},
    "medium": {price:469,length:29.5, wasserfest:44},
    "large": {price:559,length:39.3, wasserfest:45},
    "x large": {price:764,length:59, wasserfest:46},
    "xx large": {price:1289,length:78.7, wasserfest:47},
    "supersized":{price:1799,length:94.4, wasserfest:48}
},
/*
13 letters
*/
{
    "small": {price:359,length:19.6, wasserfest:43},
    "medium": {price:494,length:29.5, wasserfest:44},
    "large": {price:589,length:39.3, wasserfest:45},
    "x large": {price:799,length:59, wasserfest:46},
    "xx large": {price:1329,length:78.7, wasserfest:47},
    "supersized":{price:1849,length:94.4, wasserfest:48}
},
/*
14 letters
*/
{
    "small": {price:379,length:19.6, wasserfest:43},
    "medium": {price:519,length:29.5, wasserfest:44},
    "large": {price:619,length:39.3, wasserfest:45},
    "x large": {price:834,length:59, wasserfest:46},
    "xx large": {price:1369,length:78.7, wasserfest:47},
    "supersized":{price:1899,length:94.4, wasserfest:48}
},
/*
15 letters
*/
{
    "small": {price:399,length:19.6, wasserfest:43},
    "medium": {price:544,length:29.5, wasserfest:44},
    "large": {price:649,length:39.3, wasserfest:45},
    "x large": {price:869,length:59, wasserfest:46},
    "xx large": {price:1409,length:78.7, wasserfest:47},
    "supersized":{price:1949,length:94.4, wasserfest:48}
},
/*
16 letters
*/
{
    "small": {price:419,length:19.6, wasserfest:43},
    "medium": {price:569,length:29.5, wasserfest:44},
    "large": {price:679,length:39.3, wasserfest:45},
    "x large": {price:904,length:59, wasserfest:46},
    "xx large": {price:1449,length:78.7, wasserfest:47},
    "supersized":{price:1999,length:94.4, wasserfest:48}
},
/*
17 letters
*/
{
    "small": {price:439,length:19.6, wasserfest:43},
    "medium": {price:594,length:29.5, wasserfest:44},
    "large": {price:607,length:39.3, wasserfest:45},
    "x large": {price:939,length:59, wasserfest:46},
    "xx large": {price:1489,length:78.7, wasserfest:47},
    "supersized":{price:2049,length:94.4, wasserfest:48}
},
/*
18 letters
*/
{
    "small": {price:459,length:19.6, wasserfest:43},
    "medium": {price:619,length:29.5, wasserfest:44},
    "large": {price:739,length:39.3, wasserfest:45},
    "x large": {price:979,length:59, wasserfest:46},
    "xx large": {price:1529,length:78.7, wasserfest:47},
    "supersized":{price:2099,length:94.4, wasserfest:48}
},
/*
19 letters
*/
{
    "small": {price:479,length:19.6, wasserfest:43},
    "medium": {price:644,length:29.5, wasserfest:44},
    "large": {price:769,length:39.3, wasserfest:45},
    "x large": {price:1004,length:59, wasserfest:46},
    "xx large": {price:1569,length:78.7, wasserfest:47},
    "supersized":{price:2149,length:94.4, wasserfest:48}
},
/*
20 letters
*/
{
    "small": {price:499,length:19.6, wasserfest:43},
    "medium": {price:669,length:29.5, wasserfest:44},
    "large": {price:799,length:39.3, wasserfest:45},
    "x large": {price:1044,length:59, wasserfest:46},
    "xx large": {price:1609,length:78.7, wasserfest:47},
    "supersized":{price:2199,length:94.4, wasserfest:48}
},
/*
21 letters
*/
{
    "small": {price:519,length:19.6, wasserfest:43},
    "medium": {price:694,length:29.5, wasserfest:44},
    "large": {price:829,length:39.3, wasserfest:45},
    "x large": {price:1079,length:59, wasserfest:46},
    "xx large": {price:1649,length:78.7, wasserfest:47},
    "supersized":{price:2249,length:94.4, wasserfest:48}
},
/*
22 letters
*/
{
    "small": {price:539,length:19.6, wasserfest:43},
    "medium": {price:719,length:29.5, wasserfest:44},
    "large": {price:859,length:39.3, wasserfest:45},
    "x large": {price:1114,length:59, wasserfest:46},
    "xx large": {price:1689,length:78.7, wasserfest:47},
    "supersized":{price:2299,length:94.4, wasserfest:48}
},
/*
23 letters
*/
{
    "small": {price:559,length:19.6, wasserfest:43},
    "medium": {price:744,length:29.5, wasserfest:44},
    "large": {price:889,length:39.3, wasserfest:45},
    "x large": {price:1149,length:59, wasserfest:46},
    "xx large": {price:1729,length:78.7, wasserfest:47},
    "supersized":{price:2349,length:94.4, wasserfest:48}
},
/*
24 letters
*/
{
    "small": {price:579,length:19.6, wasserfest:43},
    "medium": {price:769,length:29.5, wasserfest:44},
    "large": {price:909,length:39.3, wasserfest:45},
    "x large": {price:1184,length:59, wasserfest:46},
    "xx large": {price:1769,length:78.7, wasserfest:47},
    "supersized":{price:2399,length:94.4, wasserfest:48}
},
/*
25 letters
*/
{
    "small": {price:599,length:19.6, wasserfest:43},
    "medium": {price:794,length:29.5, wasserfest:44},
    "large": {price:939,length:39.3, wasserfest:45},
    "x large": {price:1219,length:59, wasserfest:46},
    "xx large": {price:1809,length:78.7, wasserfest:47},
    "supersized":{price:2449,length:94.4, wasserfest:48}
},
/*
26 letters
*/
{
    "small": {price:619,length:19.6, wasserfest:43},
    "medium": {price:819,length:29.5, wasserfest:44},
    "large": {price:969,length:39.3, wasserfest:45},
    "x large": {price:1254,length:59, wasserfest:46},
    "xx large": {price:1849,length:78.7, wasserfest:47},
    "supersized":{price:2499,length:94.4, wasserfest:48}
},
/*
27 letters
*/
{
    "small": {price:639,length:19.6, wasserfest:43},
    "medium": {price:844,length:29.5, wasserfest:44},
    "large": {price:999,length:39.3, wasserfest:45},
    "x large": {price:1289,length:59, wasserfest:46},
    "xx large": {price:1889,length:78.7, wasserfest:47},
    "supersized":{price:2549,length:94.4, wasserfest:48}
},
/*
28 letters
*/
{
    "small": {price:659,length:19.6, wasserfest:43},
    "medium": {price:869,length:29.5, wasserfest:44},
    "large": {price:1029,length:39.3, wasserfest:45},
    "x large": {price:1324,length:59, wasserfest:46},
    "xx large": {price:1929,length:78.7, wasserfest:47},
    "supersized":{price:2599,length:94.4, wasserfest:48}
},
/*
29 letters
*/
{
    "small": {price:679,length:19.6, wasserfest:43},
    "medium": {price:894,length:29.5, wasserfest:44},
    "large": {price:1059,length:39.3, wasserfest:45},
    "x large": {price:1359,length:59, wasserfest:46},
    "xx large": {price:1969,length:78.7, wasserfest:47},
    "supersized":{price:2649,length:94.4, wasserfest:48}
},
/*
30 letters
*/
{
    "small": {price:699,length:19.6, wasserfest:43},
    "medium": {price:919,length:29.5, wasserfest:44},
    "large": {price:1089,length:39.3, wasserfest:45},
    "x large": {price:1394,length:59, wasserfest:46},
    "xx large": {price:2009,length:78.7, wasserfest:47},
    "supersized":{price:2699,length:94.4, wasserfest:48}
},
/*
31 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
32 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
33 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
34 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
35 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
36 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
37 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
38 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
39 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
40 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }
],
"normal":[
{
    "small": {price:119,length:7.8, wasserfest:40},
    "medium": {price:149,length:11.8, wasserfest:41},
    "large": {price:169,length:19.6, wasserfest:42},
    "x large": {price:189,length:29.5, wasserfest:43},
    "xx large": {price:229,length:39.3, wasserfest:44},
    "supersized":{price:329,length:59, wasserfest:45}
},
/*
2 letters
*/
{
    "small": {price:155,length:11.8, wasserfest:42},
    "medium": {price:159,length:19.6, wasserfest:43},
    "large": {price:214,length:29.5, wasserfest:44},
    "x large": {price:259,length:39.3, wasserfest:45},
    "xx large": {price:369,length:59, wasserfest:46},
    "supersized":{price:899,length:78.7, wasserfest:47}
},
/*
3 letters
*/
{
    "small": {price:169,length:19.6, wasserfest:43},
    "medium": {price:239,length:29.5, wasserfest:44},
    "large": {price:289,length:39.3, wasserfest:45},
    "x large": {price:419,length:59, wasserfest:46},
    "xx large": {price:939,length:78.7, wasserfest:47},
    "supersized":{price:1349,length:94.4, wasserfest:48}
},
/*
4 letters
*/
{
    "small": {price:179,length:19.6, wasserfest:43},
    "medium": {price:264,length:29.5, wasserfest:44},
    "large": {price:319,length:39.3, wasserfest:45},
    "x large": {price:489,length:59, wasserfest:46},
    "xx large": {price:979,length:78.7, wasserfest:47},
    "supersized":{price:1399,length:94.4, wasserfest:48}
},
/*
5 letters
*/
{
    "small": {price:189,length:19.6, wasserfest:43},
    "medium": {price:289,length:29.5, wasserfest:44},
    "large": {price:349,length:39.3, wasserfest:45},
    "x large": {price:539,length:59, wasserfest:46},
    "xx large": {price:1019,length:78.7, wasserfest:47},
    "supersized":{price:1449,length:94.4, wasserfest:48}
},
/*
6 letters
*/
{
    "small": {price:199,length:19.6, wasserfest:43},
    "medium": {price:314,length:29.5, wasserfest:44},
    "large": {price:379,length:39.3, wasserfest:45},
    "x large": {price:589,length:59, wasserfest:46},
    "xx large": {price:1059,length:78.7, wasserfest:47},
    "supersized":{price:1499,length:94.4, wasserfest:48}
},
/*
7 letters
*/
{
    "small": {price:219,length:19.6, wasserfest:43},
    "medium": {price:339,length:29.5, wasserfest:44},
    "large": {price:409,length:39.3, wasserfest:45},
    "x large": {price:629,length:59, wasserfest:46},
    "xx large": {price:1099,length:78.7, wasserfest:47},
    "supersized":{price:1549,length:94.4, wasserfest:48}
},
/*
8 letters
*/
{
    "small": {price:239,length:19.6, wasserfest:43},
    "medium": {price:364,length:29.5, wasserfest:44},
    "large": {price:439,length:39.3, wasserfest:45},
    "x large": {price:649,length:59, wasserfest:46},
    "xx large": {price:1139,length:78.7, wasserfest:47},
    "supersized":{price:1599,length:94.4, wasserfest:48}
},
/*
9 letters
*/
{
    "small": {price:259,length:19.6, wasserfest:43},
    "medium": {price:389,length:29.5, wasserfest:44},
    "large": {price:469,length:39.3, wasserfest:45},
    "x large": {price:679,length:59, wasserfest:46},
    "xx large": {price:1179,length:78.7, wasserfest:47},
    "supersized":{price:1649,length:94.4, wasserfest:48}
},
/*
10 letters
*/
{
    "small": {price:279,length:19.6, wasserfest:43},
    "medium": {price:414,length:29.5, wasserfest:44},
    "large": {price:499,length:39.3, wasserfest:45},
    "x large": {price:699,length:59, wasserfest:46},
    "xx large": {price:1219,length:78.7, wasserfest:47},
    "supersized":{price:1699,length:94.4, wasserfest:48}
},
/*
11 letters
*/
{
    "small": {price:299,length:19.6, wasserfest:43},
    "medium": {price:439,length:29.5, wasserfest:44},
    "large": {price:529,length:39.3, wasserfest:45},
    "x large": {price:729,length:59, wasserfest:46},
    "xx large": {price:1249,length:78.7, wasserfest:47},
    "supersized":{price:1749,length:94.4, wasserfest:48}
},
/*
12 letters
*/
{
    "small": {price:339,length:19.6, wasserfest:43},
    "medium": {price:469,length:29.5, wasserfest:44},
    "large": {price:559,length:39.3, wasserfest:45},
    "x large": {price:764,length:59, wasserfest:46},
    "xx large": {price:1289,length:78.7, wasserfest:47},
    "supersized":{price:1799,length:94.4, wasserfest:48}
},
/*
13 letters
*/
{
    "small": {price:359,length:19.6, wasserfest:43},
    "medium": {price:494,length:29.5, wasserfest:44},
    "large": {price:589,length:39.3, wasserfest:45},
    "x large": {price:799,length:59, wasserfest:46},
    "xx large": {price:1329,length:78.7, wasserfest:47},
    "supersized":{price:1849,length:94.4, wasserfest:48}
},
/*
14 letters
*/
{
    "small": {price:379,length:19.6, wasserfest:43},
    "medium": {price:519,length:29.5, wasserfest:44},
    "large": {price:619,length:39.3, wasserfest:45},
    "x large": {price:834,length:59, wasserfest:46},
    "xx large": {price:1369,length:78.7, wasserfest:47},
    "supersized":{price:1899,length:94.4, wasserfest:48}
},
/*
15 letters
*/
{
    "small": {price:399,length:19.6, wasserfest:43},
    "medium": {price:544,length:29.5, wasserfest:44},
    "large": {price:649,length:39.3, wasserfest:45},
    "x large": {price:869,length:59, wasserfest:46},
    "xx large": {price:1409,length:78.7, wasserfest:47},
    "supersized":{price:1949,length:94.4, wasserfest:48}
},
/*
16 letters
*/
{
    "small": {price:419,length:19.6, wasserfest:43},
    "medium": {price:569,length:29.5, wasserfest:44},
    "large": {price:679,length:39.3, wasserfest:45},
    "x large": {price:904,length:59, wasserfest:46},
    "xx large": {price:1449,length:78.7, wasserfest:47},
    "supersized":{price:1999,length:94.4, wasserfest:48}
},
/*
17 letters
*/
{
    "small": {price:439,length:19.6, wasserfest:43},
    "medium": {price:594,length:29.5, wasserfest:44},
    "large": {price:607,length:39.3, wasserfest:45},
    "x large": {price:939,length:59, wasserfest:46},
    "xx large": {price:1489,length:78.7, wasserfest:47},
    "supersized":{price:2049,length:94.4, wasserfest:48}
},
/*
18 letters
*/
{
    "small": {price:459,length:19.6, wasserfest:43},
    "medium": {price:619,length:29.5, wasserfest:44},
    "large": {price:739,length:39.3, wasserfest:45},
    "x large": {price:979,length:59, wasserfest:46},
    "xx large": {price:1529,length:78.7, wasserfest:47},
    "supersized":{price:2099,length:94.4, wasserfest:48}
},
/*
19 letters
*/
{
    "small": {price:479,length:19.6, wasserfest:43},
    "medium": {price:644,length:29.5, wasserfest:44},
    "large": {price:769,length:39.3, wasserfest:45},
    "x large": {price:1004,length:59, wasserfest:46},
    "xx large": {price:1569,length:78.7, wasserfest:47},
    "supersized":{price:2149,length:94.4, wasserfest:48}
},
/*
20 letters
*/
{
    "small": {price:499,length:19.6, wasserfest:43},
    "medium": {price:669,length:29.5, wasserfest:44},
    "large": {price:799,length:39.3, wasserfest:45},
    "x large": {price:1044,length:59, wasserfest:46},
    "xx large": {price:1609,length:78.7, wasserfest:47},
    "supersized":{price:2199,length:94.4, wasserfest:48}
},
/*
21 letters
*/
{
    "small": {price:519,length:19.6, wasserfest:43},
    "medium": {price:694,length:29.5, wasserfest:44},
    "large": {price:829,length:39.3, wasserfest:45},
    "x large": {price:1079,length:59, wasserfest:46},
    "xx large": {price:1649,length:78.7, wasserfest:47},
    "supersized":{price:2249,length:94.4, wasserfest:48}
},
/*
22 letters
*/
{
    "small": {price:539,length:19.6, wasserfest:43},
    "medium": {price:719,length:29.5, wasserfest:44},
    "large": {price:859,length:39.3, wasserfest:45},
    "x large": {price:1114,length:59, wasserfest:46},
    "xx large": {price:1689,length:78.7, wasserfest:47},
    "supersized":{price:2299,length:94.4, wasserfest:48}
},
/*
23 letters
*/
{
    "small": {price:559,length:19.6, wasserfest:43},
    "medium": {price:744,length:29.5, wasserfest:44},
    "large": {price:889,length:39.3, wasserfest:45},
    "x large": {price:1149,length:59, wasserfest:46},
    "xx large": {price:1729,length:78.7, wasserfest:47},
    "supersized":{price:2349,length:94.4, wasserfest:48}
},
/*
24 letters
*/
{
    "small": {price:579,length:19.6, wasserfest:43},
    "medium": {price:769,length:29.5, wasserfest:44},
    "large": {price:909,length:39.3, wasserfest:45},
    "x large": {price:1184,length:59, wasserfest:46},
    "xx large": {price:1769,length:78.7, wasserfest:47},
    "supersized":{price:2399,length:94.4, wasserfest:48}
},
/*
25 letters
*/
{
    "small": {price:599,length:19.6, wasserfest:43},
    "medium": {price:794,length:29.5, wasserfest:44},
    "large": {price:939,length:39.3, wasserfest:45},
    "x large": {price:1219,length:59, wasserfest:46},
    "xx large": {price:1809,length:78.7, wasserfest:47},
    "supersized":{price:2449,length:94.4, wasserfest:48}
},
/*
26 letters
*/
{
    "small": {price:619,length:19.6, wasserfest:43},
    "medium": {price:819,length:29.5, wasserfest:44},
    "large": {price:969,length:39.3, wasserfest:45},
    "x large": {price:1254,length:59, wasserfest:46},
    "xx large": {price:1849,length:78.7, wasserfest:47},
    "supersized":{price:2499,length:94.4, wasserfest:48}
},
/*
27 letters
*/
{
    "small": {price:639,length:19.6, wasserfest:43},
    "medium": {price:844,length:29.5, wasserfest:44},
    "large": {price:999,length:39.3, wasserfest:45},
    "x large": {price:1289,length:59, wasserfest:46},
    "xx large": {price:1889,length:78.7, wasserfest:47},
    "supersized":{price:2549,length:94.4, wasserfest:48}
},
/*
28 letters
*/
{
    "small": {price:659,length:19.6, wasserfest:43},
    "medium": {price:869,length:29.5, wasserfest:44},
    "large": {price:1029,length:39.3, wasserfest:45},
    "x large": {price:1324,length:59, wasserfest:46},
    "xx large": {price:1929,length:78.7, wasserfest:47},
    "supersized":{price:2599,length:94.4, wasserfest:48}
},
/*
29 letters
*/
{
    "small": {price:679,length:19.6, wasserfest:43},
    "medium": {price:894,length:29.5, wasserfest:44},
    "large": {price:1059,length:39.3, wasserfest:45},
    "x large": {price:1359,length:59, wasserfest:46},
    "xx large": {price:1969,length:78.7, wasserfest:47},
    "supersized":{price:2649,length:94.4, wasserfest:48}
},
/*
30 letters
*/
{
    "small": {price:699,length:19.6, wasserfest:43},
    "medium": {price:919,length:29.5, wasserfest:44},
    "large": {price:1089,length:39.3, wasserfest:45},
    "x large": {price:1394,length:59, wasserfest:46},
    "xx large": {price:2009,length:78.7, wasserfest:47},
    "supersized":{price:2699,length:94.4, wasserfest:48}
},
/*
31 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },    
/*
32 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
33 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
34 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
35 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
36 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
37 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
38 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
39 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }, 
/*
40 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 } 
],
  "expensive":[
{
    "small": {price:119,length:7.8, wasserfest:40},
    "medium": {price:159,length:11.8, wasserfest:41},
    "large": {price:169,length:19.6, wasserfest:42},
    "x large": {price:189,length:29.5, wasserfest:43},
    "xx large": {price:229,length:39.3, wasserfest:44},
    "supersized":{price:329,length:59, wasserfest:45}
},
{
    "small": {price:155,length:11.8, wasserfest:42},
    "medium": {price:169,length:19.6, wasserfest:43},
    "large": {price:234,length:29.5, wasserfest:44},
    "x large": {price:259,length:39.3, wasserfest:45},
    "xx large": {price:369,length:59, wasserfest:46},
    "supersized":{price:899,length:78.7, wasserfest:47}
},
{
    "small": {price:169,length:19.6, wasserfest:43},
    "medium": {price:249,length:29.5, wasserfest:44},
    "large": {price:299,length:39.3, wasserfest:45},
    "x large": {price:419,length:59, wasserfest:46},
    "xx large": {price:949,length:78.7, wasserfest:47},
    "supersized":{price:1369,length:94.4, wasserfest:48}
},
{
    "small": {price:179,length:19.6, wasserfest:43},
    "medium": {price:274,length:29.5, wasserfest:44},
    "large": {price:339,length:39.3, wasserfest:45},
    "x large": {price:499,length:59, wasserfest:46},
    "xx large": {price:999,length:78.7, wasserfest:47},
    "supersized":{price:1419,length:94.4, wasserfest:48}
},
{
    "small": {price:189,length:19.6, wasserfest:43},
    "medium": {price:299,length:29.5, wasserfest:44},
    "large": {price:349,length:39.3, wasserfest:45},
    "x large": {price:539,length:59, wasserfest:46},
    "xx large": {price:1039,length:78.7, wasserfest:47},
    "supersized":{price:1449,length:94.4, wasserfest:48}
},
{
    "small": {price:199,length:19.6, wasserfest:43},
    "medium": {price:324,length:29.5, wasserfest:44},
    "large": {price:379,length:39.3, wasserfest:45},
    "x large": {price:589,length:59, wasserfest:46},
    "xx large": {price:1079,length:78.7, wasserfest:47},
    "supersized":{price:1529,length:94.4, wasserfest:48}
},
/*
7 letters
*/
{
    "small": {price:219,length:19.6, wasserfest:43},
    "medium": {price:339,length:29.5, wasserfest:44},
    "large": {price:409,length:39.3, wasserfest:45},
    "x large": {price:629,length:59, wasserfest:46},
    "xx large": {price:1099,length:78.7, wasserfest:47},
    "supersized":{price:1549,length:94.4, wasserfest:48}
},
/*
8 letters
*/
{
    "small": {price:239,length:19.6, wasserfest:43},
    "medium": {price:364,length:29.5, wasserfest:44},
    "large": {price:439,length:39.3, wasserfest:45},
    "x large": {price:649,length:59, wasserfest:46},
    "xx large": {price:1139,length:78.7, wasserfest:47},
    "supersized":{price:1599,length:94.4, wasserfest:48}
},
/*
9 letters
*/
{
    "small": {price:259,length:19.6, wasserfest:43},
    "medium": {price:389,length:29.5, wasserfest:44},
    "large": {price:469,length:39.3, wasserfest:45},
    "x large": {price:679,length:59, wasserfest:46},
    "xx large": {price:1179,length:78.7, wasserfest:47},
    "supersized":{price:1649,length:94.4, wasserfest:48}
},
/*
10 letters
*/
{
    "small": {price:279,length:19.6, wasserfest:43},
    "medium": {price:414,length:29.5, wasserfest:44},
    "large": {price:499,length:39.3, wasserfest:45},
    "x large": {price:699,length:59, wasserfest:46},
    "xx large": {price:1219,length:78.7, wasserfest:47},
    "supersized":{price:1699,length:94.4, wasserfest:48}
},
/*
11 letters
*/
{
    "small": {price:299,length:19.6, wasserfest:43},
    "medium": {price:434,length:29.5, wasserfest:44},
    "large": {price:529,length:39.3, wasserfest:45},
    "x large": {price:729,length:59, wasserfest:46},
    "xx large": {price:1249,length:78.7, wasserfest:47},
    "supersized":{price:1749,length:94.4, wasserfest:48}
},
/*
12 letters
*/
{
    "small": {price:339,length:19.6, wasserfest:43},
    "medium": {price:469,length:29.5, wasserfest:44},
    "large": {price:559,length:39.3, wasserfest:45},
    "x large": {price:764,length:59, wasserfest:46},
    "xx large": {price:1289,length:78.7, wasserfest:47},
    "supersized":{price:1799,length:94.4, wasserfest:48}
},
/*
13 letters
*/
{
    "small": {price:359,length:19.6, wasserfest:43},
    "medium": {price:494,length:29.5, wasserfest:44},
    "large": {price:589,length:39.3, wasserfest:45},
    "x large": {price:799,length:59, wasserfest:46},
    "xx large": {price:1329,length:78.7, wasserfest:47},
    "supersized":{price:1849,length:94.4, wasserfest:48}
},
/*
14 letters
*/
{
    "small": {price:379,length:19.6, wasserfest:43},
    "medium": {price:519,length:29.5, wasserfest:44},
    "large": {price:619,length:39.3, wasserfest:45},
    "x large": {price:834,length:59, wasserfest:46},
    "xx large": {price:1369,length:78.7, wasserfest:47},
    "supersized":{price:1899,length:94.4, wasserfest:48}
},
/*
15 letters
*/
{
    "small": {price:399,length:19.6, wasserfest:43},
    "medium": {price:544,length:29.5, wasserfest:44},
    "large": {price:649,length:39.3, wasserfest:45},
    "x large": {price:869,length:59, wasserfest:46},
    "xx large": {price:1409,length:78.7, wasserfest:47},
    "supersized":{price:1949,length:94.4, wasserfest:48}
},
/*
16 letters
*/
{
    "small": {price:419,length:19.6, wasserfest:43},
    "medium": {price:569,length:29.5, wasserfest:44},
    "large": {price:679,length:39.3, wasserfest:45},
    "x large": {price:904,length:59, wasserfest:46},
    "xx large": {price:1449,length:78.7, wasserfest:47},
    "supersized":{price:1999,length:94.4, wasserfest:48}
},
/*
17 letters
*/
{
    "small": {price:439,length:19.6, wasserfest:43},
    "medium": {price:594,length:29.5, wasserfest:44},
    "large": {price:607,length:39.3, wasserfest:45},
    "x large": {price:939,length:59, wasserfest:46},
    "xx large": {price:1489,length:78.7, wasserfest:47},
    "supersized":{price:2049,length:94.4, wasserfest:48}
},
/*
18 letters
*/
{
    "small": {price:459,length:19.6, wasserfest:43},
    "medium": {price:619,length:29.5, wasserfest:44},
    "large": {price:739,length:39.3, wasserfest:45},
    "x large": {price:979,length:59, wasserfest:46},
    "xx large": {price:1529,length:78.7, wasserfest:47},
    "supersized":{price:2099,length:94.4, wasserfest:48}
},
/*
19 letters
*/
{
    "small": {price:479,length:19.6, wasserfest:43},
    "medium": {price:644,length:29.5, wasserfest:44},
    "large": {price:769,length:39.3, wasserfest:45},
    "x large": {price:1004,length:59, wasserfest:46},
    "xx large": {price:1569,length:78.7, wasserfest:47},
    "supersized":{price:2149,length:94.4, wasserfest:48}
},
/*
20 letters
*/
{
    "small": {price:499,length:19.6, wasserfest:43},
    "medium": {price:669,length:29.5, wasserfest:44},
    "large": {price:799,length:39.3, wasserfest:45},
    "x large": {price:1044,length:59, wasserfest:46},
    "xx large": {price:1609,length:78.7, wasserfest:47},
    "supersized":{price:2199,length:94.4, wasserfest:48}
},
/*
21 letters
*/
{
    "small": {price:519,length:19.6, wasserfest:43},
    "medium": {price:694,length:29.5, wasserfest:44},
    "large": {price:829,length:39.3, wasserfest:45},
    "x large": {price:1079,length:59, wasserfest:46},
    "xx large": {price:1649,length:78.7, wasserfest:47},
    "supersized":{price:2249,length:94.4, wasserfest:48}
},
/*
22 letters
*/
{
    "small": {price:539,length:19.6, wasserfest:43},
    "medium": {price:719,length:29.5, wasserfest:44},
    "large": {price:859,length:39.3, wasserfest:45},
    "x large": {price:1114,length:59, wasserfest:46},
    "xx large": {price:1689,length:78.7, wasserfest:47},
    "supersized":{price:2299,length:94.4, wasserfest:48}
},
/*
23 letters
*/
{
    "small": {price:559,length:19.6, wasserfest:43},
    "medium": {price:744,length:29.5, wasserfest:44},
    "large": {price:889,length:39.3, wasserfest:45},
    "x large": {price:1149,length:59, wasserfest:46},
    "xx large": {price:1729,length:78.7, wasserfest:47},
    "supersized":{price:2349,length:94.4, wasserfest:48}
},
/*
24 letters
*/
{
    "small": {price:579,length:19.6, wasserfest:43},
    "medium": {price:769,length:29.5, wasserfest:44},
    "large": {price:909,length:39.3, wasserfest:45},
    "x large": {price:1184,length:59, wasserfest:46},
    "xx large": {price:1769,length:78.7, wasserfest:47},
    "supersized":{price:2399,length:94.4, wasserfest:48}
},
/*
25 letters
*/
{
    "small": {price:599,length:19.6, wasserfest:43},
    "medium": {price:794,length:29.5, wasserfest:44},
    "large": {price:939,length:39.3, wasserfest:45},
    "x large": {price:1219,length:59, wasserfest:46},
    "xx large": {price:1809,length:78.7, wasserfest:47},
    "supersized":{price:2449,length:94.4, wasserfest:48}
},
/*
26 letters
*/
{
    "small": {price:619,length:19.6, wasserfest:43},
    "medium": {price:819,length:29.5, wasserfest:44},
    "large": {price:969,length:39.3, wasserfest:45},
    "x large": {price:1254,length:59, wasserfest:46},
    "xx large": {price:1849,length:78.7, wasserfest:47},
    "supersized":{price:2499,length:94.4, wasserfest:48}
},
/*
27 letters
*/
{
    "small": {price:639,length:19.6, wasserfest:43},
    "medium": {price:844,length:29.5, wasserfest:44},
    "large": {price:999,length:39.3, wasserfest:45},
    "x large": {price:1289,length:59, wasserfest:46},
    "xx large": {price:1889,length:78.7, wasserfest:47},
    "supersized":{price:2549,length:94.4, wasserfest:48}
},
/*
28 letters
*/
{
    "small": {price:659,length:19.6, wasserfest:43},
    "medium": {price:869,length:29.5, wasserfest:44},
    "large": {price:1029,length:39.3, wasserfest:45},
    "x large": {price:1324,length:59, wasserfest:46},
    "xx large": {price:1929,length:78.7, wasserfest:47},
    "supersized":{price:2599,length:94.4, wasserfest:48}
},
/*
29 letters
*/
{
    "small": {price:679,length:19.6, wasserfest:43},
    "medium": {price:894,length:29.5, wasserfest:44},
    "large": {price:1059,length:39.3, wasserfest:45},
    "x large": {price:1359,length:59, wasserfest:46},
    "xx large": {price:1969,length:78.7, wasserfest:47},
    "supersized":{price:2649,length:94.4, wasserfest:48}
},
/*
30 letters
*/
{
    "small": {price:699,length:19.6, wasserfest:43},
    "medium": {price:919,length:29.5, wasserfest:44},
    "large": {price:1089,length:39.3, wasserfest:45},
    "x large": {price:1394,length:59, wasserfest:46},
    "xx large": {price:2009,length:78.7, wasserfest:47},
    "supersized":{price:2699,length:94.4, wasserfest:48}
},
/*
31 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
32 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
33 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
34 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
35 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
36 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
37 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
38 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
39 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 },
/*
40 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
 }
],
  "premium":[
{
    "small": {price:149,length:7.8, wasserfest:40},
    "medium": {price:189,length:11.8, wasserfest:41},
    "large": {price:199,length:19.6, wasserfest:42},
    "x large": {price:249,length:29.5, wasserfest:43},
    "xx large": {price:279,length:39.3, wasserfest:44},
    "supersized":{price:379,length:59, wasserfest:45}
},
{
    "small": {price:180,length:11.8, wasserfest:42},
    "medium": {price:199,length:19.6, wasserfest:43},
    "large": {price:264,length:29.5, wasserfest:44},
    "x large": {price:309,length:39.3, wasserfest:45},
    "xx large": {price:419,length:59, wasserfest:46},
    "supersized":{price:949,length:78.7, wasserfest:47}
},
{
    "small": {price:185,length:19.6, wasserfest:43},
    "medium": {price:279,length:29.5, wasserfest:44},
    "large": {price:299,length:39.3, wasserfest:45},
    "x large": {price:519,length:59, wasserfest:46},
    "xx large": {price:999,length:78.7, wasserfest:47},
    "supersized":{price:1419,length:94.4, wasserfest:48}
},
{
    "small": {price:189,length:19.6, wasserfest:43},
    "medium": {price:304,length:29.5, wasserfest:44},
    "large": {price:339,length:39.3, wasserfest:45},
    "x large": {price:589,length:59, wasserfest:46},
    "xx large": {price:1049,length:78.7, wasserfest:47},
    "supersized":{price:1469,length:94.4, wasserfest:48}
},
{
    "small": {price:195,length:19.6, wasserfest:43},
    "medium": {price:319,length:29.5, wasserfest:44},
    "large": {price:349,length:39.3, wasserfest:45},
    "x large": {price:629,length:59, wasserfest:46},
    "xx large": {price:1089,length:78.7, wasserfest:47},
    "supersized":{price:1499,length:94.4, wasserfest:48}
},
{
    "small": {price:199,length:19.6, wasserfest:43},
    "medium": {price:344,length:29.5, wasserfest:44},
    "large": {price:379,length:39.3, wasserfest:45},
    "x large": {price:679,length:59, wasserfest:46},
    "xx large": {price:1139,length:78.7, wasserfest:47},
    "supersized":{price:1579,length:94.4, wasserfest:48}
},
/*
7 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:389,length:29.5, wasserfest:44},
    "large": {price:409,length:39.3, wasserfest:45},
    "x large": {price:629,length:59, wasserfest:46},
    "xx large": {price:1099,length:78.7, wasserfest:47},
    "supersized":{price:1749,length:94.4, wasserfest:48}
},
/*
8 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:414,length:29.5, wasserfest:44},
    "large": {price:439,length:39.3, wasserfest:45},
    "x large": {price:649,length:59, wasserfest:46},
    "xx large": {price:1139,length:78.7, wasserfest:47},
    "supersized":{price:1799,length:94.4, wasserfest:48}
},
/*
9 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:439,length:29.5, wasserfest:44},
    "large": {price:469,length:39.3, wasserfest:45},
    "x large": {price:679,length:59, wasserfest:46},
    "xx large": {price:1179,length:78.7, wasserfest:47},
    "supersized":{price:1849,length:94.4, wasserfest:48}
},
/*
10 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:464,length:29.5, wasserfest:44},
    "large": {price:499,length:39.3, wasserfest:45},
    "x large": {price:699,length:59, wasserfest:46},
    "xx large": {price:1219,length:78.7, wasserfest:47},
    "supersized":{price:1899,length:94.4, wasserfest:48}
},
/*
11 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:484,length:29.5, wasserfest:44},
    "large": {price:529,length:39.3, wasserfest:45},
    "x large": {price:729,length:59, wasserfest:46},
    "xx large": {price:1249,length:78.7, wasserfest:47},
    "supersized":{price:1949,length:94.4, wasserfest:48}
},
/*
12 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:519,length:29.5, wasserfest:44},
    "large": {price:559,length:39.3, wasserfest:45},
    "x large": {price:764,length:59, wasserfest:46},
    "xx large": {price:1289,length:78.7, wasserfest:47},
    "supersized":{price:1999,length:94.4, wasserfest:48}
},
/*
13 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:544,length:29.5, wasserfest:44},
    "large": {price:589,length:39.3, wasserfest:45},
    "x large": {price:799,length:59, wasserfest:46},
    "xx large": {price:1329,length:78.7, wasserfest:47},
    "supersized":{price:2049,length:94.4, wasserfest:48}
},
/*
14 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:569,length:29.5, wasserfest:44},
    "large": {price:619,length:39.3, wasserfest:45},
    "x large": {price:834,length:59, wasserfest:46},
    "xx large": {price:1369,length:78.7, wasserfest:47},
    "supersized":{price:2099,length:94.4, wasserfest:48}
},
/*
15 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:594,length:29.5, wasserfest:44},
    "large": {price:649,length:39.3, wasserfest:45},
    "x large": {price:869,length:59, wasserfest:46},
    "xx large": {price:1409,length:78.7, wasserfest:47},
    "supersized":{price:2149,length:94.4, wasserfest:48}
},
/*
16 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:619,length:29.5, wasserfest:44},
    "large": {price:679,length:39.3, wasserfest:45},
    "x large": {price:904,length:59, wasserfest:46},
    "xx large": {price:1449,length:78.7, wasserfest:47},
    "supersized":{price:2199,length:94.4, wasserfest:48}
},
/*
17 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:644,length:29.5, wasserfest:44},
    "large": {price:679,length:39.3, wasserfest:45},
    "x large": {price:939,length:59, wasserfest:46},
    "xx large": {price:1489,length:78.7, wasserfest:47},
    "supersized":{price:2249,length:94.4, wasserfest:48}
},
/*
18 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:669,length:29.5, wasserfest:44},
    "large": {price:739,length:39.3, wasserfest:45},
    "x large": {price:979,length:59, wasserfest:46},
    "xx large": {price:1529,length:78.7, wasserfest:47},
    "supersized":{price:2299,length:94.4, wasserfest:48}
},
/*
19 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:694,length:29.5, wasserfest:44},
    "large": {price:769,length:39.3, wasserfest:45},
    "x large": {price:1004,length:59, wasserfest:46},
    "xx large": {price:1569,length:78.7, wasserfest:47},
    "supersized":{price:2349,length:94.4, wasserfest:48}
},
/*
20 letters
*/
{
    "small": {price:0,length:19.6, wasserfest:43},
    "medium": {price:719,length:29.5, wasserfest:44},
    "large": {price:799,length:39.3, wasserfest:45},
    "x large": {price:1044,length:59, wasserfest:46},
    "xx large": {price:1609,length:78.7, wasserfest:47},
    "supersized":{price:2399,length:94.4, wasserfest:48}
},
/*
21 letters
*/
{
    "small": {price:519,length:19.6, wasserfest:43},
    "medium": {price:744,length:29.5, wasserfest:44},
    "large": {price:829,length:39.3, wasserfest:45},
    "x large": {price:1079,length:59, wasserfest:46},
    "xx large": {price:1649,length:78.7, wasserfest:47},
    "supersized":{price:2449,length:94.4, wasserfest:48}
},
/*
22 letters
*/
{
    "small": {price:539,length:19.6, wasserfest:43},
    "medium": {price:719,length:29.5, wasserfest:44},
    "large": {price:859,length:39.3, wasserfest:45},
    "x large": {price:1114,length:59, wasserfest:46},
    "xx large": {price:1689,length:78.7, wasserfest:47},
    "supersized":{price:2499,length:94.4, wasserfest:48}
},
/*
23 letters
*/
{
    "small": {price:559,length:19.6, wasserfest:43},
    "medium": {price:769,length:29.5, wasserfest:44},
    "large": {price:889,length:39.3, wasserfest:45},
    "x large": {price:1149,length:59, wasserfest:46},
    "xx large": {price:1729,length:78.7, wasserfest:47},
    "supersized":{price:2549,length:94.4, wasserfest:48}
},
/*
24 letters
*/
{
    "small": {price:579,length:19.6, wasserfest:43},
    "medium": {price:794,length:29.5, wasserfest:44},
    "large": {price:909,length:39.3, wasserfest:45},
    "x large": {price:1184,length:59, wasserfest:46},
    "xx large": {price:1769,length:78.7, wasserfest:47},
    "supersized":{price:2599,length:94.4, wasserfest:48}
},
/*
25 letters
*/
{
    "small": {price:599,length:19.6, wasserfest:43},
    "medium": {price:819,length:29.5, wasserfest:44},
    "large": {price:939,length:39.3, wasserfest:45},
    "x large": {price:1219,length:59, wasserfest:46},
    "xx large": {price:1809,length:78.7, wasserfest:47},
    "supersized":{price:2649,length:94.4, wasserfest:48}
},
/*
26 letters
*/
{
    "small": {price:619,length:19.6, wasserfest:43},
    "medium": {price:844,length:29.5, wasserfest:44},
    "large": {price:969,length:39.3, wasserfest:45},
    "x large": {price:1254,length:59, wasserfest:46},
    "xx large": {price:1849,length:78.7, wasserfest:47},
    "supersized":{price:2699,length:94.4, wasserfest:48}
},
/*
27 letters
*/
{
    "small": {price:639,length:19.6, wasserfest:43},
    "medium": {price:869,length:29.5, wasserfest:44},
    "large": {price:999,length:39.3, wasserfest:45},
    "x large": {price:1289,length:59, wasserfest:46},
    "xx large": {price:1889,length:78.7, wasserfest:47},
    "supersized":{price:2749,length:94.4, wasserfest:48}
},
/*
28 letters
*/
{
    "small": {price:659,length:19.6, wasserfest:43},
    "medium": {price:894,length:29.5, wasserfest:44},
    "large": {price:1029,length:39.3, wasserfest:45},
    "x large": {price:1324,length:59, wasserfest:46},
    "xx large": {price:1929,length:78.7, wasserfest:47},
    "supersized":{price:2799,length:94.4, wasserfest:48}
},
/*
29 letters
*/
{
    "small": {price:679,length:19.6, wasserfest:43},
    "medium": {price:919,length:29.5, wasserfest:44},
    "large": {price:1059,length:39.3, wasserfest:45},
    "x large": {price:1359,length:59, wasserfest:46},
    "xx large": {price:1969,length:78.7, wasserfest:47},
    "supersized":{price:2849,length:94.4, wasserfest:48}
},
/*
30 letters
*/
{
    "small": {price:699,length:19.6, wasserfest:43},
    "medium": {price:944,length:29.5, wasserfest:44},
    "large": {price:1089,length:39.3, wasserfest:45},
    "x large": {price:1394,length:59, wasserfest:46},
    "xx large": {price:2009,length:78.7, wasserfest:47},
    "supersized":{price:2899,length:94.4, wasserfest:48}
},
/*
31 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
32 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
33 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
34 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
35 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
36 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
37 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
38 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
39 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 },
/*
40 letters
*/
{
    "small": {price:719,length:19.6, wasserfest:43},
    "medium": {price:969,length:29.5, wasserfest:44},
    "large": {price:1109,length:39.3, wasserfest:45},
    "x large": {price:1429,length:59, wasserfest:46},
    "xx large": {price:2049,length:78.7, wasserfest:47},
    "supersized":{price:2949,length:94.4, wasserfest:48}
 }
]}        